<template>
  <div class="courseExchange">
    <div class="courseExchange-count">
      <p>可用次数：<output>{{courseExchangeCount}}</output></p>
    </div>
    <h2 class="courseExchange-title">
      —  请选择以下课程进行兑换  —
    </h2>
    <div class="courseExchange-content">
      <div class="courseExchange-block" v-for="(item, index) in courseExchangeData" :key="item.name">
        <h2 class="courseExchange-grade">{{item.name}}</h2>
        <div class="courseExchange-course">
          <ul class="courseExchange-course-list" v-if="item.courses">
            <li v-for="v in item.courses" :key="v.course_id"
             :class="['courseExchange-course-item', v.status === '1' ? 'courseExchange-course-item-exchanged' : '', v.course_id === checkedCourseId ? 'courseExchange-course-item-checked' : '']" @click="toggleCourseChecked(v, index)">
              <span>{{v.name.substr(0,6)}}</span>
              <i class="icon icon-duigou"></i>
              <b v-if="v.status === '1'"> 已兑 </b>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div v-if="courseExchangeData.length <= 0" class="courseExchange-none">
      暂无课程可兑换，请关注活动更新！
    </div>
    <!-- End: 没有可兑换课程。 目前不会有这种情况 -->
    <div :class="['courseExchange-btn', `courseExchange-btn-${checkedCourseId ? '' : 'disable'}`]" @click="exchangeCourse">确认兑换</div>
    <login-handle ref="loginHandle" />
    <!-- End: 未登录登录处理。 -->
  </div>
</template>
<script>
import LoginHandle from '../components/LoginHandle'

export default {
  name: 'CourseExchange',
  components: { LoginHandle },
  data () {
    return {
      appVersion: 0,
      checkedCourseId: '', // 单选
      shareCountForGold: 0, // （可以获得金币的分享次数）分享次数（最多3次）
      courseExchangeData: [], // 可兑换课程列表
      courseExchangeCount: '--', // 课程兑换次数
      isApp: /jzh$/i.test(navigator.userAgent) // 是否是原生app
    }
  },
  mounted () {
    if (this.isApp) {
      // 获取当前app版本。判断ios版本号，是否支持分享小程序
      const deviceInfo = JSON.parse(xesApp.deviceInfo())
      this.appVersion = deviceInfo.appVersionNumber
    }
    this.setPageData()
  },
  methods: {
    // 切换课程选择(单选)
    toggleCourseChecked (course) {
      if (course.status === '1') return
      const courseId = course.course_id
      // 选中点击则取消
      this.checkedCourseId = courseId === this.checkedCourseId ? '' : courseId
    },
    // 兑换课程
    exchangeCourse () {
      const { checkedCourseId } = this
      this.$xesLogger.clickMsg({ params: { clickid: '3.2.3', action: 'exchangeCourse' } })
      // 未选择课程
      if (!checkedCourseId) return this.$toast('请先选择课程')
      // 没有兑换次数
      if (this.courseExchangeCount <= 0) {
        this.$xesLogger.clickMsg({ params: { clickid: '3.2.4', actionName: '没有兑换次数' } })
        return this.$dialog.confirm({
          confirmButtonColor: '#E02727',
          message: '暂无兑换机会'
        }).then(() => {
          this.$xesLogger.clickMsg({ params: { clickid: '3.2.5', actionName: '去邀请' } })
        }).catch(() => {
          this.$xesLogger.clickMsg({ params: { clickid: '3.2.7', actionName: '取消去邀请弹窗' } })
        })
      }
      // 可以正常兑换
      this.$dialog.confirm({
        confirmButtonText: '确认兑换',
        confirmButtonColor: '#E02727',
        message: '将消耗1次机会，确定兑换吗？'
      }).then(async () => {
        this.$xesLogger.clickMsg({ params: { clickid: '3.2.6', actionName: '确认兑换课程' } })
        const result = await this.$api.exchangeCourse(checkedCourseId)
        const { code, data } = result
        if (code === 2003) return this.$toast.fail('兑换次数不足，刷新页面后重试！')
        if (code !== 0) return this.$toast.fail('兑换失败，请稍后重试！')
        this.checkedCourseId = ''
        this.courseExchangeCount = data.use_num
        this.courseExchangeData = this.courseExchangeData.map(item => {
          item.courses.map(v => {
            if (checkedCourseId === v.course_id) v.status = '1'
          })
          return item
        })
        this.$dialog.alert({
          confirmButtonText: '确认',
          confirmButtonColor: '#E02727',
          message: '兑换成功，课程请至「学习中心 > 录播课」查看'
        })
        this.$xesLogger.clickMsg({ params: { clickid: '3.2.6.1', actionName: '兑换课程成功', status: '1' } })
      })
    },
    // 请求兑换课程列表
    setPageData () {
      this.$api.getCourseExchangeData().then(result => {
        const { code, data } = result
        if (code !== 0) return this.$refs.loginHandle.callLogin()
        this.courseExchangeCount = data.use_num || 0
        this.courseExchangeData = data.course_list || []
      })
    }
  }
}
</script>
<style lang="less" scoped>
.courseExchange {
  padding: 26px 20px;
  font-weight: 500;

  .courseExchange-count {
    font-size: 12px;
    text-align: left;

    p {
      output {
        color: #e02727;
      }
    }
  }

  .courseExchange-title {
    margin: 14px 0 28px;
    font-size: 17px;
    font-family: 'FZLanTingHeiS-DB-GB Regular';
    color: #e02727;
  }

  .courseExchange-content {
    .courseExchange-block {
      margin-top: 10px;

      .courseExchange-grade {
        text-align: left;
      }

      .courseExchange-course {
        .courseExchange-course-list {
          display: flex;
          flex-wrap: wrap;
          padding: 15px;
          font-size: 13px;
          font-weight: 300;
          line-height: 26px;
          color: #333;

          .courseExchange-course-item {
            position: relative;
            display: inline-block;
            width: 48%;
            height: 26px;
            margin-bottom: 13px;
            overflow: hidden;
            line-height: 26px;
            white-space: nowrap;
            border: 1px solid #e02727;
            border-radius: 13px;
            text-overflow: ellipsis;

            &:nth-child(2n) {
              margin-left: 4%;
            }

            & > i,
            b {
              position: absolute;
              right: 8px;
              display: none;
            }

            .icon-duigou {
              top: 7px;
              width: 11px;
              height: 9px;
            }

            &-checked {
              color: #fff;
              background: linear-gradient(180deg, #fd6053 0%, #e02727 98%);
              border: 1px;

              .icon-duigou {
                display: inline-block;
              }
            }

            &-exchanged {
              border-color: #e1e1e1;
              font-weight: 400;
              background: #e1e1e1;

              & > b {
                display: inline;
                font-size: 9px;
                font-weight: 500;
                color: #e02727;
              }
            }
          }
        }
      }
    }
  }

  .courseExchange-btn {
    display: block;
    height: 34px;
    margin: 70px 15px 0;
    font-size: 18px;
    line-height: 34px;
    color: #fff;
    background: linear-gradient(180deg, #fd6053 0%, #e02727 98%);
    border-radius: 17px;

    &-disable {
      background: #e1e1e1;
    }
  }
}
</style>
